"use client";

import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

type GlobalStatsIntroContextValue = {
  playIntro: boolean;
  markIntroPlayed: () => void;
};

const GlobalStatsIntroContext = createContext<GlobalStatsIntroContextValue | null>(null);

export function GlobalStatsIntroProvider({ children }: { children: ReactNode }) {
  const [introPlayed, setIntroPlayed] = useState(false);
  const markIntroPlayed = useCallback(() => {
    setIntroPlayed(true);
  }, []);

  const value = useMemo(
    () => ({
      playIntro: !introPlayed,
      markIntroPlayed,
    }),
    [introPlayed, markIntroPlayed],
  );

  return (
    <GlobalStatsIntroContext.Provider value={value}>{children}</GlobalStatsIntroContext.Provider>
  );
}

export function useGlobalStatsIntro() {
  const value = useContext(GlobalStatsIntroContext);
  if (!value) {
    throw new Error("useGlobalStatsIntro must be used within GlobalStatsIntroProvider");
  }
  return value;
}
